enum ActionType {
  EXPAND_PAYMENT_INFO,
  RESET_CLICKED_STATE,
}

interface AccountDetailsState {
  accountOnHoldLinkClicked: boolean
}

export { ActionType, AccountDetailsState }
